





































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { IPushBulkRequeueResult, PayloadState, PushState } from '@/types/types';

@Component({
  name: 'PushBulkRequeueDialog',
})
export default class PushBulkRequeueDialog extends Vue {
  @Prop({ required: true, default: false }) state!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: null }) result!: IPushBulkRequeueResult | null;
  @Prop({ default: 'EXHAUSTED' }) pushState!: PushState;
  @Prop({ default: 500 }) limit!: number;

  reason: string = '';

  get stateLabel(): string {
    return this.pushState.toLowerCase();
  }

  @Watch('state')
  onStateChange(open: boolean): void {
    if (!open) return;
    this.reason = '';
  }

  @Emit('actions')
  cancel(): PayloadState {
    return { idx: 'bulkRequeue', state: false };
  }

  @Emit('preview')
  preview() {
    return { reason: this.reason || undefined };
  }

  @Emit('confirm')
  confirm() {
    return { reason: this.reason || undefined };
  }
}
